module.exports = __webpack_public_path__ + "img/ch09_16_店门挥手.0fa62a38.jpg";